import { Button } from '@cian/ui-kit/button';
import { Plans3D16 } from '@cian/ui-kit/icons';
import * as React from 'react';

import * as styles from './tourButton.css';

export const TourButton = ({ handler }: { handler(): void }) => {
  return (
    <div className={styles['tour']}>
      <Button
        data-name="TourButton"
        onClick={handler}
        size="XS"
        theme="stroke_primary"
        beforeIcon={<Plans3D16 color="primary_100" />}
      >
        3D–тур по квартире
      </Button>
    </div>
  );
};
